import './ccf-typography.module.scss';
import { Typography , TypographyProps } from '@mui/material';
import {withTranslation,withTranslationProps,CcfTranslationKey} from '../../ccf-translator/ccf-translator';


/**
 * 
 * @param props - TypographyProps
 * @example CcfTypographyWrapper(children,other)
 * @returns 
 */
function CcfTypographyWrapper({children,...other}: TypographyProps ) {
  return (
    <Typography {...other} >
      {children}
    </Typography>
  );
}

/**
 * 
 * @param props - TypographyProps
 * @example <CcfTranslatedTypography />
 * @returns 
 */
const CcfTranslatedTypography = ({ translator , locale, translationKey , children , ...other }: TypographyProps & withTranslationProps ) => {
  const translatedText = translator(translationKey as CcfTranslationKey) || children
  return (
    <Typography children={translatedText} {...other} />
  )
}

export const CcfTypography =  withTranslation(CcfTranslatedTypography)